<template>
  <div class="mt-6">
    <div>{{ showStatus }}</div>
    <div v-show="neverLoaded">Loading... please wait.</div>
    <div v-show="aboutToStartText" class="divide-y divide-gray-200">
      <div>
        <h1 class="status text-2xl mb-2 text-gray-900 font-extrabold tracking-tight">
          {{ aboutToStartText }}</h1>
        <ul>
          <li class="mx-auto mb-8 flex w-full flex-wrap lg:flex-nowrap text-white"
              v-for="(session, index) in sessionsImminent"
              :key="session.id">
            <div
                class="session-wrapping relative mx-auto basis-full items-center justify-between rounded-xl p-6 text-black md:flex lg:flex-1 lg:basis-0 bg-gradient"
            >
              <div class="flex-1 md:mx-[2.5rem] md:flex md:space-x-6">
                <div class="px-4 md:flex-1 md:px-0">
                  <SessionLiveHeader :session="session"></SessionLiveHeader>
                  <p class="text-sm mt-1 text-black">{{ getTime(session.starts_at, session.ends_at) }}</p>
                  <SessionLiveData
                      :hasTicket="hasTicket"
                      :isUser="isUser"
                      :isMember="isMember"
                      :session="session"></SessionLiveData>
                  <SessionLiveLocation :session="session"></SessionLiveLocation>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>


    </div>
    <div v-show="inProgressText" class="divide-y divide-gray-200">
      <div>
        <h1 class="status text-2xl mb-2 text-gray-900 font-extrabold tracking-tight">
          {{ inProgressText }}</h1>
        <ul>
          <li class="mx-auto mb-8 flex w-full flex-wrap lg:flex-nowrap text-white"
              v-for="(session, index) in sessionsInProgress"
              :key="session.id">
            <div
                class="session-wrapping relative mx-auto basis-full items-center justify-between rounded-xl p-6 text-black md:flex lg:flex-1 lg:basis-0 bg-gradient"
            >
              <div class="flex-1 md:mx-[2.5rem] md:flex md:space-x-6">
                <div class="px-4 md:flex-1 md:px-0">
                  <SessionLiveHeader :session="session"></SessionLiveHeader>
                  <p class="text-sm mt-1 text-black">{{ getTime(session.starts_at, session.ends_at) }}</p>
                  <SessionLiveData
                      :hasTicket="hasTicket"
                      :isUser="isUser"
                      :isMember="isMember"
                      :session="session"></SessionLiveData>
                  <SessionLiveLocation :session="session"></SessionLiveLocation>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>


    </div>
    <div v-show="nextText" class="divide-y divide-gray-200">
      <div>
        <h1 class="status text-2xl mb-2 text-gray-900 font-extrabold tracking-tight">
          Later Sessions</h1>
        <p class="text-sm">Note: See <a class="underline" href="/sessions/responsive">sessions list</a> for the complete list.</p>
        <ul>
          <li class="mx-auto mb-8 flex w-full flex-wrap lg:flex-nowrap text-white"
              v-for="(session, index) in sessionsNext"
              :key="session.id">
            <div
                class="session-wrapping relative mx-auto basis-full items-center justify-between rounded-xl p-6 text-black md:flex lg:flex-1 lg:basis-0 bg-gradient"
            >
              <div class="flex-1 md:mx-[2.5rem] md:flex md:space-x-6">
                <div class="px-4 md:flex-1 md:px-0">
                  <SessionLiveHeader :session="session"></SessionLiveHeader>
                  <p class="text-sm mt-1 text-black">{{ getTime(session.starts_at, session.ends_at) }}</p>
                  <SessionLiveLocation :session="session"></SessionLiveLocation>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>


    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import {ref} from "vue";
import SessionLiveLocation from "./SessionLiveLocation.vue";
import SessionLiveHeader from "./SessionLiveHeader.vue";
import SessionLiveData from "./SessionLiveData.vue";

const {DateTime} = require("luxon");

export default {
  name: "SessionLive",
  components: {SessionLiveData, SessionLiveHeader, SessionLiveLocation},
  computed: {
    aboutToStartText: function () {
//return this.imminentSessions.length ? 'About to Start' : '';
      return this.sessionData.imminent?.length ? 'Upcoming Sessions (starting soon)' : ''
    },
    inProgressText: function () {
//return this.sessionsInProgress.length ? 'In Progress' : '';
      return this.sessionData.inProgress?.length ? 'In Progress' : ''
    },
    nextText: function () {
//return this.sessionsInProgress.length ? 'In Progress' : '';
      return this.sessionData.next?.length ? 'Later Sessions' : ''
    },
    showLaterSessions: function (){
      if (this.sessionData.imminent?.length && this.sessionData.inProgress?.length) {
        return false;
      }
      return true;
    },
    showStatus: function () {
//return (this.sessionsInProgress.length || this.imminentSessions.length) ? '' : this.inStatus;
    },
    inStatus: function () {
      return "We're on a break - take a look at the schedule page.";
      /*if (this.relativeTime === -1) {
      return "Event hasn't started. Please come back later.";
      }
      if (this.relativeTime === 1) {
      return "Event has finished.";
      }*/

    },
    sessionsInProgress: function () {
      return this.sessionData.inProgress;
    },
    sessionsImminent: function () {
      return this.sessionData.imminent;
    },
    sessionsNext: function () {
      return this.sessionData.next;
    }
  },

  props:
      {
        event: {
          type: Object,
          required: true
        },
        relativeTime: {
          type: Number,
          required: true,
        },
        timezone: {
          type: String,
          required: true,
        },
        isMember: {
          type: Number,
          required: true
        },
        isUser: {
          type: Number,
          required: true
        },
        hasTicket: {
          type: Number,
          required: true
        }
      },
  data() {
    return {
//sessions: [],
//imminentSessions: [],
//sessionsInProgress: [],
      interval: null,
      neverLoaded: true,
      sessionData: {
        inProgress: [],
        imminent: [],
        next: []
      },
    }
  },
  setup(props) {
    const event = props.event;
    const timezone = props.timezone;
    const isMember = !!props.isMember;
    const isUser = !!props.isUser;
    const hasTicket = !!props.hasTicket;

    
    return {
      event,
      timezone,
      isMember,
      hasTicket,
      isUser

    }
  },
  created() {

    this.fetchItems();
    setInterval(function () {
      this.fetchItems();
    }.bind(this), 30000);


  },
  methods: {

    organizationUrl: function (session) {
      const organization = {};
      if (session.organization) {
        return '/organization/' + session.organization.id;
      }
      return '';
    },


// https://stackoverflow.com/questions/48980380/returning-data-from-axios-api
    fetchItems: function () {
//console.log("Fetch");

      axios.get('/schedule/live/all')
          .then(response => (this.sessionData = response.data))
          .finally(()=> {
            this.neverLoaded = false;
          });



      /*axios.get('/api/event/' + this.event.id + '/schedule/live/imminent')
      .then(response => (this.imminentSessions = response.data));

      axios.get('/api/event/' + this.event.id + '/schedule/live/in-progress')
      .then(response => (this.sessionsInProgress = response.data));*/
    },
    showName: function (p) {
      const name = p.member && p.member.name;
      if (name) {
        return name;
      }
      return p && p.temp_name;
    },

    tagColor: function (session) {
      return 'color: white; background:' + session?.type?.color;
    },
    sessionTagColor: function (session) {
      if (session === 'youtube') {
        return 'color: #FFF; background: #F00';
      }
      return 'color: #FFF; background: #009';
    },
    link: function (id) {
      return '/session/' + id;
    },
    goToUrl: function (session) {
      if (session.hasVirtual) {
        return session.authUrl;
      }

      return '/session/' + session.id;

    },
    goToLocationUrl: function (session) {
      return '/session-locations/' + session.location.id;
    },
    avatar: function (link) {
      return '/' + link;
    },
    getTime: function (isoTimeStart, isoTimeEnd) {

      let dS = DateTime.fromISO(isoTimeStart).setZone(this.timezone).toLocaleString();
      let dE = DateTime.fromISO(isoTimeEnd).setZone(this.timezone).toLocaleString();

      if (dS === dE) {
        return DateTime.fromISO(isoTimeStart).setZone(this.timezone).toFormat("LLL d, hh:mm a")
            + ' ~ ' + DateTime.fromISO(isoTimeEnd).setZone(this.timezone).toFormat("hh:mm a")
            + ' ' + this.timezone;
      }

      return DateTime.fromISO(isoTimeStart).setZone(this.timezone).toFormat("LLL d, hh:mm a")
          + ' ~ ' + DateTime.fromISO(isoTimeEnd).setZone(this.timezone).toFormat("LLL d, hh:mm a")
          + ' ' + this.timezone;

    },


    /*
        removeFromArrayFilter: function (array, id) {

      let remove = id;

      let filtered = array.filter(function (value, index, fullArray) {
//console.log(value.id !== remove);
        return value.id !== remove;
      });

      return filtered;
    },
    removeIndex: function (array, id) {
    let removeIndex = array.map(function (item) {
    return item.id;
    }).indexOf(id);
    return array.slice(removeIndex, 1);
    }
    */

    /*
    window.Echo.channel('live-sessions')
    .listen('LiveSessionsUpdated', ({session}) => {

    //console.log(session.id);
    //console.log(action);

    if (session.event_id === this.event.id) {
    if (session_progress === 15) {  // moved to about to start
    //console.log(session.id);
    //console.log('imminent');
    this.imminentSessions.push(session);
    this.sessionsInProgress = this.removeFromArrayFilter(this.sessionsInProgress, session.id);

    } else if (session_progress === 20) {  // moved to in progress
    //console.log(session.id);
    //console.log('in progress');

    // prevent duplication
    if (this.sessionsInProgress.includes(session) === false){
    this.sessionsInProgress.push(session);
    }

    this.imminentSessions = this.removeFromArrayFilter(this.imminentSessions, session.id);
    //this.imminentSessions = this.removeIndex(this.imminentSessions, session.id);
    } else {  // moved to anything else
    this.sessionsInProgress = this.removeFromArrayFilter(this.sessionsInProgress, session.id);
    this.imminentSessions = this.removeFromArrayFilter(this.imminentSessions, session.id);
    }
    }
    });
    */
  }


};
</script>

<style scoped>

.delimiter {
  color: #ccc;
}

.pr {
  color: #666;
}

span.hide-last-delimiter:last-child span.delimiter {
  display: none;
}

.session-wrapping {
  background-color: rgba(0, 0, 0, 0.01);
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.session-wrapping a {
  color: rgb(79, 70, 229);
}

.session-wrapping a.text-white {
  color: #FFF;
}

</style>
